const boxStyle = {
  border: '5px solid',
  width: '100%',
  marginTop: 10,
  padding: 10,
  textAlign: 'center',
};

export default boxStyle;
